import React, { Component } from 'react';
import { CQMasterDataStore } from '../../../../store/cq-master-data.store';
import { TemplateSFObjectStore } from '../../../../store/models/template-object.model';
import { observer } from 'mobx-react';
import { GridCustomCumponentFieldVisibilityRuletModal } from './row-actions/custom-component-field-visibility';
import GridTemplateConfigurationController from '../grid-template-config.controller';

class GridTableComponent extends Component<any, any>{
    private templateConfigCtrl: GridTemplateConfigurationController;
    constructor(props: any) {
        super(props);
        this.templateConfigCtrl = new GridTemplateConfigurationController();
        this.state = {
            isRowChecked: false,
            isEditable: false,
            selectedIndex: 0,
            isApplyRuleModalVisisble: false,
            selectedCustomComponent: {}
        }
    }

    render() {
        const componentLevelConfigTabData = CQMasterDataStore.GridObject.gridComponentConfigView;
        const headerActionType = CQMasterDataStore.GridObject.headerActionTypes;
        const isCheckboxVisible = headerActionType.length && headerActionType.some((action: any) => {
            if (action.hasOwnProperty('bulk') && action.bulk) {
                return true
            }
            return false;
        });
        
        let ruleElement = CQMasterDataStore.OutputConfig.getStoreKeyData(this.props.selectedTemplateName, 'ruleElements');
        const gridObject= ruleElement.hasOwnProperty('gridObject') ? { ...ruleElement.gridObject } : {};
        const rowActions = gridObject.hasOwnProperty('rowActions') ? {...gridObject.rowActions} : {};
        return (
            <div className="slds-scrollable_x full-height">
                <table className="slds-table slds-table_bordered slds-table_cell-buffer grid-component-table ">
                    <thead>
                        <tr>
                            <th></th>
                            {
                                componentLevelConfigTabData.displayFields && componentLevelConfigTabData.displayFields.length && componentLevelConfigTabData.displayFields.map((column: any, index: number) => {
                                    if (typeof (column) === 'object') {
                                        const columnKey = Object.keys(column)[0];
                                        return <th key={index}>{columnKey.replace('customComponent', 'compoundComponent')} : {column[columnKey]}</th>
                                    } else {
                                        return <th key={index}>{column}</th>
                                    }
                                })
                            }
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {isCheckboxVisible ? (<td>
                                <div className="slds-checkbox">
                                    <input type="checkbox" name="options" checked={true} />
                                    <label className="slds-checkbox__label">
                                        <span className="slds-checkbox_faux"></span>
                                    </label>
                                </div>
                            </td>) : (
								<td />
							)}
							{componentLevelConfigTabData.fieldsToDisplay &&
								componentLevelConfigTabData.fieldsToDisplay.length &&
								componentLevelConfigTabData.fieldsToDisplay.map(
									(row: any, index: number) => {
										if (
											row.hasOwnProperty("type") &&
											row.type === "customComponent"
										) {
											return (
												<td key={index}>
													{/* {row.label} */}
                                                    {
                                                        row.fields.length > 0 && row.fields.map((field: any, index: number) => {
                                                            return(
                                                                <div key={index}>
                                                                    {field.label}{field.displayField ? ` - ${field.referenceLabel}` : null}
                                                                    <span className="slds-col slds-p-right_none">
                                                                        <button
                                                                            className="slds-button slds-text-color_default"
                                                                            role="edit-btn"
                                                                            onClick={() => {
                                                                                this.toggleRuleModalVisibility(index, row);
                                                                            }}
                                                                        >
                                                                            { 
                                                                                field.hasOwnProperty("visible") 
                                                                                    ? 
                                                                                <i className="cq-icon-eye"></i> 
                                                                                    : 
                                                                                <i className="cq-icon-edit"></i> 
                                                                            }
                                                                        </button>
                                                                    </span>
                                                                </div>
                                                            )
                                                        })
                                                    }
												</td>
											);
										} else {
											return <td key={index}>Sample Data</td>;
										}
									}
								)}
                            <td className="slds-grid slds-grid_align-end">
                                <div className="slds-button-group" role="group">
                                    {/* <button className="slds-button slds-button_neutral">Edit Selected</button> */}
                                    <button className="slds-button slds-button_icon slds-button_icon-border-filled"
                                        onClick={this.props.toggleModalVisibility} >
                                        <i className="cq-icon-change_record_type"></i>
                                    </button>
                                    <div className={`slds-dropdown-trigger slds-dropdown-trigger_click slds-button_last ${this.state.isEditable && 'slds-is-open'}`}>
                                        <button className="slds-button slds-button_icon slds-button_icon-border-filled" aria-haspopup="true" title="Show More" onClick={this.toggleEditDropDown}>
                                            <i className="cq-icon-down"></i>
                                        </button>
                                        <div className="slds-dropdown slds-dropdown_right slds-dropdown_actions">
                                            <ul className="slds-dropdown__list" role="menu">
                                                {this.props.rowActionType.length && this.props.rowActionType.map((rowAction: any) => {
                                                    if (rowAction.hasOwnProperty('component_name') || rowAction.hasOwnProperty('componentName')) {
                                                        return <li className="slds-dropdown__item slds-grid slds-grid_vertical-align-center slds-grid_align-spread" role="presentation" onClick={() => this.selectedRowAction(rowAction.name, 'addedCustomRowAction')}>
                                                            <a>
                                                                <span className="slds-truncate">{rowAction.name}</span>
                                                            </a>
                                                            {
                                                                rowActions.hasOwnProperty(rowAction.name) && rowActions[rowAction.name].isRuleApplied ? <i className="cq-icon-eye"></i> : null
                                                            }
                                                        </li>
                                                    } else {
                                                        return <li className="slds-dropdown__item slds-grid slds-grid_vertical-align-center slds-grid_align-spread" role="presentation" onClick={() => this.selectedRowAction(rowAction.name, 'standardRowAction')}>
                                                            <a>
                                                                <span className="slds-truncate">{rowAction.name}</span>
                                                            </a>
                                                            {
                                                                rowActions.hasOwnProperty(rowAction.name) && rowActions[rowAction.name].isRuleApplied ? <i className="cq-icon-eye"></i> : null
                                                            }
                                                        </li>
                                                    }
                                                })}
                                                <li className="slds-dropdown__item slds-p-around_x-small" role="presentation" >
                                                    <a className="slds-button slds-button_outline-brand" onClick={() => this.selectedRowAction('customAction', 'customRowAction')}>
                                                        <span className="slds-truncate">Define Custom Action</span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </td>
                        </tr>
                    </tbody>
                </table>
                {
                    this.state.isApplyRuleModalVisisble && <GridCustomCumponentFieldVisibilityRuletModal
                        selectedTemplateName={this.props.selectedTemplateName}
                        toggleModalVisibility={this.toggleRuleModalVisibility}
                        actionType="fieldsVisibilityRules"
                        updateVisibilityRuleObj={this.updateVisibilityRuleObj}
                        selectedIndex={this.state.selectedIndex}
                        selectedCustomComponent={this.state.selectedCustomComponent}
                    />
                }
            </div>
        )
    }

    private updateVisibilityRuleObj = (ruleObject: {visible: any}) => {
        const { label, type, groupName, fields } = this.state.selectedCustomComponent;

        const customFields = fields.map((field: any, index: number) => {
            if(index === this.state.selectedIndex){
                if(ruleObject.visible === true){
                    delete field.visible
                }else{
                    field.visible = ruleObject.visible;
                }
            }
            return field
        });

        let gridObject: any;
        
        let ruleElements = CQMasterDataStore.OutputConfig.getStoreKeyData(this.props.selectedTemplateName, 'ruleElements');
        if (ruleElements.hasOwnProperty('gridObject')) {
            gridObject = { ...ruleElements.gridObject };
            const fieldsToDisplay = gridObject.gridComponentConfigView.fieldsToDisplay.map((field: any, key: number) => {
                if(field.label === label && field.type === type && field.groupName === groupName){
                    field.fields = customFields;
                }
                return field;
            });
            
            gridObject.gridComponentConfigView.fieldsToDisplay = fieldsToDisplay;
            ruleElements.gridObject = gridObject;
        }

        CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(this.props.selectedTemplateName, 'ruleElements', ruleElements);
        CQMasterDataStore.GridObject.updateGridField('gridComponentConfigView', gridObject.gridComponentConfigView);
        let displayFieldsArray = Array.from(new Set(gridObject.gridComponentConfigView.fieldsToDisplay));
        this.templateConfigCtrl.updateFieldValue('fields', displayFieldsArray, this.props.selectedTemplateName);
    }

    private toggleRuleModalVisibility = (index: number, row: object) => {
        this.setState({
            isApplyRuleModalVisisble: !this.state.isApplyRuleModalVisisble,
            selectedIndex: index,
            selectedCustomComponent: row
        });
    }

    private selectedRowAction = (name: string, actionType: string) => {
        const selectedAction = {
            name,
            actionType
        }
        CQMasterDataStore.GridObject.updateGridField('selectedRowAction', selectedAction);
        CQMasterDataStore.GridObject.updateGridField('selectedAction', actionType);
        this.setState({
            isEditable: !this.state.isEditable
        })
    }

    private toggleEditDropDown = () => {
        this.setState({
            isEditable: !this.state.isEditable
        })
    }
}

export const GridTable = observer(GridTableComponent)